'use strict';
import {createActions} from '../../framework';

const normalActions = ['RESET_STORE', 'SET_ACTIVE_ITEM'];

const sidebarMenuContainerActions = createActions(null, normalActions);
export default sidebarMenuContainerActions;
